/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */

import { type FireAnalyticsEvent } from '../../common/utils/analytics/types';

export type CacheRequestName = 'search-combined-config' | 'outbound-auth-github';

type onCacheAccessArgs = {
	requestName: CacheRequestName;
	cacheHit: boolean;
	refreshTriggered: boolean;
	source: string;
};

// Record the hit/miss rate of request caching.
export const onRequestCacheAccess = ({
	requestName,
	cacheHit,
	refreshTriggered,
	source,
}: onCacheAccessArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'requestCacheAccess',
		// TODO RAOC-22 migrate analytics off search-specific naming
		actionSubject: 'searchPage',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				requestName,
				cacheHit,
				refreshTriggered,
			},
		},
	};
};
